import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useMemo, useReducer } from 'react';
import { AsyncDisqualifiedLeadFollowUpModal } from '../../../leads/modals/AsyncDisqualifiedLeadFollowUpModal';
import { AsyncCreateDealFromLeadModal } from '../../../leads/modals/AsyncCreateDealFromLeadModal';
import { jsx as _jsx } from "react/jsx-runtime";
const modalReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        objectId: action.objectId,
        modalOpen: action.modal,
        onConfirm: action.onConfirm,
        onCancel: action.onCancel,
        extraProperties: action.extraProperties
      };
    case 'CLOSE_MODAL':
      return {
        modalOpen: null,
        objectId: null,
        onConfirm: emptyFunction,
        onCancel: emptyFunction
      };
    default:
      return state;
  }
};
const initialState = {
  modalOpen: null,
  objectId: null,
  onConfirm: emptyFunction,
  onCancel: emptyFunction,
  extraProperties: {}
};
export const useLeadStageModal = () => {
  const [modalState, dispatch] = useReducer(modalReducer, initialState);
  const openModal = useCallback(modalData => {
    dispatch(Object.assign({
      type: 'OPEN_MODAL'
    }, modalData));
  }, [dispatch]);
  const closeModal = useCallback(() => {
    dispatch({
      type: 'CLOSE_MODAL'
    });
  }, [dispatch]);
  const stageValidationModal = useMemo(() => {
    switch (modalState.modalOpen) {
      case 'DEAL_CREATE':
        {
          return /*#__PURE__*/_jsx(AsyncCreateDealFromLeadModal, {
            objectId: modalState.objectId,
            onConfirm: modalState.onConfirm,
            onCancel: modalState.onCancel,
            extraProperties: modalState.extraProperties
          });
        }
      case 'RE_ATTEMPTING_LEAD_AND_TASK_REQUIRED':
      case 'FOLLOW_UP_TASK_REQUIRED':
      case 'RE_ATTEMPTING_LEAD_REQUIRED':
        {
          return /*#__PURE__*/_jsx(AsyncDisqualifiedLeadFollowUpModal, {
            objectId: modalState.objectId,
            modalType: modalState.modalOpen,
            onConfirm: modalState.onConfirm,
            onCancel: modalState.onCancel,
            extraProperties: modalState.extraProperties
          });
        }
      default:
        {
          return null;
        }
    }
  }, [modalState]);
  return useMemo(() => ({
    openModal,
    closeModal,
    stageValidationModal
  }), [openModal, closeModal, stageValidationModal]);
};